import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { UploadInvoices } from '../newClaimSteps/uploadInvoices';
import { UploadVetNotes } from '../newClaimSteps/uploadVetNotes';
import { BriefClaimSummary } from '../newClaimSteps/briefClaimSummary';
import { PetSelection } from '../newClaimSteps/petSelection';
import { VetDetails } from '../../../vetDetails/vetDetails';
import { FullPetDetailsPropTypes } from '../../../../propTypes/petDetails';
import { SavedClaimPropTypes } from '../../../../propTypes/claimDetails';
import { ClaimReimbursement } from '../newClaimSteps/claimReimbursement';
import { PETSURE_UNDERWRITER } from '../../../../constants/constants';

export const NewClaimDetails = ({
  petDetails,
  activePet,
  isReadOnly = false,
  onPetSelect,
  onPreviousStep,
  onNextStep,
  onSaveForLater,
  savedClaim,
  buttonLabel,
  hasReimbursementDetails
}) => {
  const handlePetSelection = (selection) => {
    onPetSelect(selection);
  };

  return (
    <main aria-label="New Claim Details">
      <h2 className="bottomBorder">{isReadOnly ? 'Review' : 'Enter'} claim details</h2>

      <ol className="newClaimSteps styledCounter leftAlign medium numberCircle">
        <li>
          <h3>
            This claim is for
            {petDetails?.length > 1 && !isReadOnly && (
              <span className="sr-only">Please select the pet you would like to make a claim for.</span>
            )}
          </h3>
          <PetSelection
            isReadOnly={isReadOnly}
            petDetails={petDetails}
            onPetSelection={handlePetSelection}
            activePolicyNumber={activePet?.PolicyNumber}
          />
        </li>

        <li>
          <BriefClaimSummary
            isReadOnly={isReadOnly}
            claimDescription={savedClaim?.ClaimDescription}
            selectedPet={activePet?.Name}
          />
        </li>

        <li>
          <UploadInvoices
            isReadOnly={isReadOnly}
            claimInvoices={savedClaim?.ClaimInvoices}
            policyNumber={activePet?.FullPolicyNumber ?? petDetails?.[0].policyNumber}
          />
        </li>

        <li>
          <UploadVetNotes
            isReadOnly={isReadOnly}
            vetNotes={savedClaim?.VetConsultationNotes}
            policyNumber={activePet?.FullPolicyNumber ?? petDetails?.[0].policyNumber}
          />
        </li>

        <li>
          <VetDetails
            isReadOnly={isReadOnly}
            petDetails={petDetails}
            activePolicyNumber={activePet?.PolicyNumber}
          />
        </li>

        {activePet?.Underwriter === PETSURE_UNDERWRITER && (
          <li>
            <ClaimReimbursement
              isReadOnly={isReadOnly}
              activePet={activePet}
              hasReimbursementDetails={hasReimbursementDetails}
            />
          </li>
        )}
      </ol>

      <footer className={`newClaimsStepsFooter ${isReadOnly ? 'readOnly' : ''}`}>
        {isReadOnly && (
          <div className="footerLeftActions">
            <button
              type="button"
              className="button primary outline"
              onClick={onPreviousStep}
            >
              <Icon icon="arrow-left2" />
              <span className="labelText">Back</span>
            </button>
          </div>
        )}

        <div className="footerRightActions">
          <button
            type="button"
            className="button primary outline"
            onClick={onSaveForLater}
          >
            <span className="labelText">Save for later</span>
          </button>
          <button
            type="button"
            className="button primary"
            onClick={onNextStep}
          >
            <span className="labelText">{buttonLabel}</span>
          </button>
        </div>
      </footer>
    </main>
  );
};

NewClaimDetails.propTypes = {
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes),
  activePet: FullPetDetailsPropTypes,
  isReadOnly: PropTypes.bool,
  onPetSelect: PropTypes.func,
  onPreviousStep: PropTypes.func,
  onNextStep: PropTypes.func,
  onSaveForLater: PropTypes.func,
  savedClaim: PropTypes.shape(SavedClaimPropTypes),
  buttonLabel: PropTypes.string,
  hasReimbursementDetails: PropTypes.bool
};
